export enum DatabaseStoreEnum {
  BANKS = "banks",
  SUBSCRIPTIONS = "subscriptions",
  FUTURE_INCOME = "futureIncome",
  SETTINGS = "settings",
}

export const config = {
  name: "financial-hub",
  version: 7,
  objectStoresMeta: [
    {
      store: DatabaseStoreEnum.BANKS,
      storeConfig: { keyPath: "id", autoIncrement: true },
      storeSchema: [
        { name: "name", keypath: "name", options: { unique: false } },
        { name: "balance", keypath: "balance", options: { unique: false } },
        {
          name: "balanceHistory",
          keypath: "balanceHistory",
          options: { unique: false },
        },
      ],
    },
    {
      store: DatabaseStoreEnum.SUBSCRIPTIONS,
      storeConfig: { keyPath: "id", autoIncrement: true },
      storeSchema: [
        { name: "name", keypath: "name", options: { unique: false } },
        { name: "cost", keypath: "cost", options: { unique: false } },
        { name: "period", keypath: "period", options: { unique: false } },
      ],
    },
    {
      store: DatabaseStoreEnum.FUTURE_INCOME,
      storeConfig: { keyPath: "id", autoIncrement: true },
      storeSchema: [
        {
          name: "description",
          keypath: "description",
          options: { unique: false },
        },
        { name: "date", keypath: "date", options: { unique: false } },
        { name: "balance", keypath: "balance", options: { unique: false } },
      ],
    },
    {
      store: DatabaseStoreEnum.SETTINGS,
      storeConfig: { keyPath: "id", autoIncrement: true },
      storeSchema: [
        {
          name: "faunaKey",
          keypath: "faunaKey",
          options: { unique: false },
        },
        {
          name: "lastSyncDate",
          keypath: "lastSyncDate",
          options: { unique: false },
        },
      ],
    },
  ],
};
